// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page404__wrapper__2-zDW","btnWrapper":"page404__btnWrapper__AQWT1"};